export const Infinite = "inf";
